import React, {Suspense, useState, useContext} from "react";

import {createRoot} from 'react-dom/client'
import './styles.scss'
import App from './App'

import { BrowserRouter, Outlet, Routes, Route, useLocation } from "react-router-dom";
import About from "./About";


window.history.replaceState({}, document.title)

function Layout() {
  const [show, setShow] = useState(true);
  const value = { show, setShow };

  return (
    <div className='main'>
      <Outlet />
    </div>
  );
}

function Base() {
  const location = useLocation();

  return (
    <Routes location={location}>
      <Route path="/" element={<Layout />}>
        <Route path="/" element={
          <Suspense fallback={<div>...</div>}>
            <App />
          </Suspense>}
        />
        <Route path="/cases/ambev" element={
          <Suspense fallback={<div>...</div>}>
            <About />
          </Suspense>}
        />
      </Route>
    </Routes>
  );
}


const Root = () => <BrowserRouter><Base /></BrowserRouter>;

createRoot(document.getElementById("root")).render(<Root />);
